export function buildLoginUrlWithReturn(returnTo) {
  return `/Login?returnTo=${encodeURIComponent(returnTo)}`;
}

export function parseReturnTo(search, fallback = '/') {
  try {
    const params = new URLSearchParams(search);
    const raw = params.get('returnTo');
    if (!raw) return fallback;
    // Solo permitir rutas internas conocidas (evita open-redirect)
    if (raw.startsWith('/redeem')) return raw;
    if (raw.startsWith('/wizard-ig')) return raw;
    return fallback;
  } catch (_) {
    return fallback;
  }
}
